<template>

</template>

<script>
import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import VueCookies from 'vue-cookies'

function GetDomain () {
  var l = window.location.host.split('.')
  if (l.length >= 3) {
    return l[1] + '.' + l[2]
  } else {
    return window.location.host
  }
}

Vue.use(VueCookies)

export default {
  name: 'logout',
  mounted () {
    this.$cookies.remove('.jwt', '/')
    this.$cookies.remove('.jwt', '/', GetDomain())
    store.commit('LOGOUT_USER')
    router.push('login')
  }
}
</script>



// WEBPACK FOOTER //
// src/auth/Logout.vue